/*
 * Creates rs namespace that will be used as the access point for all Lrs RS javascript
 */

var rs = (function (rs, $) {
    "use strict";
